import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InfoPageHeaderComponent} from '../../shared/components/info-page-header/info-page-header.component';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router} from '@angular/router';

@Component({
  selector: 'app-deposit-new-check-in',
  templateUrl: './deposit-new-check-in.component.html',
  styleUrls: ['./deposit-new-check-in.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, InfoPageHeaderComponent],
})
export class DepositNewCheckInComponent {

  form: FormGroup;

  constructor(private fb: FormBuilder, private router: Router) {
    this.form = this.fb.group({
      nombre: ['', Validators.required],
      apellido1: ['', Validators.required],
      nacionalidad: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
  }
}
